const templates = [
    {
        'id': 0,
        'template': '{{Sentence A}} However, {{Sentence B}}',
    },
    {
        'id': 1,
        'template': '{{Sentence A}} Nevertheless, {{Sentence B}}',
    },
    {
        'id': 2,
        'template': '{{Sentence A}} By contrast, {{Sentence B}}',
    },
]

export default templates;